import { rem } from "polished";
import styled from "styled-components";

import { BlockPaddingWrapper } from "@/components/editor/shared/block-wrapper";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/use-color";

const GAP = 24;

export const PaddingWrapper = withViewportStyle(BlockPaddingWrapper)`
  ${(props) => props.$viewport.mobile`
    padding: ${rem(80)} ${rem(16)};
  `}
`;

export const CenteredHeader = styled.div`
  margin-bottom: ${rem(40)};

  .text-primitive.headingTwo {
    text-align: center;
    color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
  }
`;

export const ContentWrapper = withViewportStyle("div")<{
  columns?: number;
}>`
  column-count: ${({ columns }) => columns};
  column-gap: ${rem(GAP)};

  & > img {
    height: auto;
    width: 100%;
    margin-bottom: ${rem(GAP)};
  }

  ${(props) => props.$viewport.mobile`
      column-count: 1;
      column-gap: unset;
  `}
`;
